export default __webpack_public_path__ + "static/media/fb.e779b252.svg";